import { isNumber } from 'lodash';
import { formatNumber } from './formatNumber';

interface NumberWithSpacesFormattingOptions {
    decimalSeparator?: string;
    postfix?: string;
    default?: string;
}

export const numberWithSpaces = (nbr: number | null | undefined, options: NumberWithSpacesFormattingOptions = {}) => {
    if (!isNumber(nbr) || Number.isNaN(nbr) || !Number.isFinite(nbr)) {
        return options.default ?? '';
    }

    const formattedNumber = formatNumber(nbr, 0, ' ');

    return `${formattedNumber}${options.postfix ?? ''}`;
};
